import { render } from "./UsersDetails.vue?vue&type=template&id=47daaa36"
import script from "./UsersDetails.vue?vue&type=script&lang=js"
export * from "./UsersDetails.vue?vue&type=script&lang=js"

import "./UsersDetails.vue?vue&type=style&index=0&id=47daaa36&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__